export const currentVersion = 'dev-99b67ea';
